import { mutator } from 'satcheljs';
import { onManuallyPickCertificateChanged } from '../actions/internalActions';
import store from '../store/store';

/**
 * Mutator that sets the property manuallyPickCertificate.
 */
export default mutator(onManuallyPickCertificateChanged, actionMessage => {
    store().isManuallyPickCertificate = actionMessage.selectedOption;
});
